export default {
  SET_SECURITYCATEGORIES: 'setSecurityCategories',
  SET_SELECTED_SECURITYCATEGORY: 'setSelectedSecurityCategory',
  SET_FIELD_TENANTS: 'setFieldTenants'
}